import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 3.75c-4.556 0-8.25 3.693-8.25 8.25s3.693 8.25 8.25 8.25a8.25 8.25 0 1 0 0-16.5zm-.092 13.391a5.19 5.19 0 1 1 0-10.38 5.19 5.19 0 0 1 0 10.38z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.346 8.844v6.324l4.944-3.162z"
  })]
}), 'YoukuRing');